import Image from '@anwb/poncho/components/image';
import { staticAssetsUrl } from 'utils/constants';

const AyvensLogo = new URL('/images/ayvens.png', staticAssetsUrl()).href;

export const AyvensImage = (
	<Image id="ayvens-logo" src={AyvensLogo} alt="Ayvens" imageWidth="half" />
);
